import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router';
import { setLanguage } from 'features/userSlice';
import PrivacyPolicyPortuguese from './pt';
import PrivacyPolicyEnglish from './en';
import PrivacyPolicySpanish from './es';

function PrivacyPolicy() {
  const user = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const defaultLanguage = searchParams.get('language');

  useEffect(() => {
    if (defaultLanguage) {
      if (defaultLanguage === 'pt-br' || defaultLanguage === 'en-us' || defaultLanguage === 'es-es') {
        dispatch(setLanguage(defaultLanguage));
        navigate('/public/privacy-policy');
      }
    }
  }, []);

  if (user.language === 'pt-br') {
    return <PrivacyPolicyPortuguese />;
  }
  if (user.language === 'es-es') {
    return <PrivacyPolicySpanish />;
  }

  return <PrivacyPolicyEnglish />;
}

export default PrivacyPolicy;
